import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { Field } from "redux-form/immutable"

import { GridToggleSelectField } from "app/static/frontend/forms/components/GridToggleSelectField"
import { selectStancesWithCustomLabels } from "shared/stance/selectors"

// generic component
export const UnconnectedBulkActionsStance = (props) => {
    const enumItems = props.stanceOptions
    return (
        <div className="bulk-actions-console-stance-form" data-cy="bulk-actions-console-stance-form">
            <Field
                allowNull={false}
                choices={enumItems.sort(DjangIO.valueSortDescending)}
                className="bulk-actions-form-stance"
                component={GridToggleSelectField}
                dropUp={false}
                multi={false}
                name="stance"
            />
        </div>
    )
}
UnconnectedBulkActionsStance.propTypes = {
    stanceOptions: PropTypes.arrayOf(PropTypes.object),
}

export default connect(createStructuredSelector({ stanceOptions: selectStancesWithCustomLabels }))(
    UnconnectedBulkActionsStance,
)
